export default __webpack_public_path__ + "static/media/aea.6b4f3965.png";